import { createStore, applyMiddleware, combineReducers } from "redux";
import ReduxThunk from "redux-thunk";
//  User
import login from "../Core/User/Login/reducer";
import confirm from "../Core/User/Confirm/reducer";
import call from "../Core/User/Call/reducer";
import profile from "../Core/User/Profile/reducer";
//  Book steps
import shoots from "../Core/Shoots/reducer";
import packages from "../Core/Packages/reducer";
import days from "../Core/Days/reducer";
import hours from "../Core/Hours/reducer";
import details from "../Core/Details/reducer";
import receipt from "../Core/Receipt/reducer";
import { photographers, photographersEq } from "../Core/Photogrphers/reducer";
import comments from "../Core/PhotographerComments/reducer";
import location from "../Core/Location/reducer";
//  projects
import project from "../Core/Projects/reducer";
//  Others
import checkout from "../Core/CheckOut/reducer";
import coupon from "../Core/Coupon/reducer";
import factor from "../Core/SendFactor/reducer";
//  To change Variables in redux
import change from '../Core/ChangeValues/reducer';
//  For Datas that before selected
import slocation from "../Core/SingleLocation/reducer";
import sphotographer from "../Core/SinglePhotographer/reducer";

//  For Get active Cities
import activeCities from '../Core/Location/ActiveCities/reducer';
import activeLocationOptions from "../Core/Location/CheckActiveOptions/reducer";
import mylocations from "../Core/MyLocations/reducer";

const reducers = combineReducers({
  login,
  confirm,
  call,
  profile,
  project,
  shoots,
  packages,
  days,
  hours,
  details,
  receipt,
  photographers,
  comments,
  locations: location,
  checkout,
  coupon,
  factor,
  change,
  slocation,
  sphotographer,
  activeCities,
  activeLocationOptions,
  photographersEq,

  mylocations,
});

export default createStore(reducers, applyMiddleware(ReduxThunk));
